<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NRVvRC/tc-custom/9781467469074.jpg?1730408159830" alt="This image is the cover for the book Paul the Storyteller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Paul the Storyteller
      </h1>
      <p class="bookDescription body article font2">
        <b>An incisive study of Paul’s use of stories and narratives in his letters</b><br/><br/> Paul is often thought of as a crafter of numerous and complex <i>arguments</i>, but some scholars, such as N. T. Wright and Richard Hays, have shown that narratives are vitally important in his letters. Through careful examination of the texts, Christoph Heilig demonstrates that Paul is indeed a talented teller of stories—not only explicit narratives but also implicit stories.<br/><br/> In this volume, after a decade of research and writing, Heilig presents his definitive report on narrative in Paul. While Richard Hays and N. T. Wright have argued that Paul’s letters contain implicit narratives, Heilig stresses that a sound methodology requires beginning with text-linguistic investigation of <i>explicit </i>narratives. As Heilig argues, focusing on explicit narratives repeatedly redirects our attention to implicit (“almost”) stories. On this basis, he shows that Hays’s “narrative substructures” and Wright’s “worldview” narratives can also be fruitfully integrated into a narratological approach. Paul is a different kind of storyteller than the gospel writers, for example, but at countless points miniature narratives play a crucial role for Paul’s communicative goals.<br/><br/> Students and scholars of the New Testament will welcome Heilig’s expert guidance through a hotly debated area of Pauline studies.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christoph Heilig
      </h2>
      
      <p class="authorDescription body article"><B>Christoph Heilig</B> leads a research group at the University of Munich that focuses on the intersection between literary studies and biblical exegesis. His books include <I>The Apostle and the Empire</I> (2022), <I>Paul&rsquo;s Triumph</I> (2017), and <I>Hidden Criticism</I> (2015). His previous book on narratives in Paul (<I>Paulus als Erz&auml;hler</I>, 2020) received a Manfred Lautenschlaeger Award for Theological Promise.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cba97d9a